import firebase_app from "@/firebase/config";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";

export default function useUser(){
    const auth = getAuth(firebase_app);
    const [user,loading] = useAuthState(auth)
    return {user,loading}
}